import { render } from "./InstanceTab.vue?vue&type=template&id=465e82f7&scoped=true"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"

import "./InstanceTab.vue?vue&type=style&index=0&id=465e82f7&lang=scss&scoped=true"
import "./InstanceTab.vue?vue&type=style&index=1&id=465e82f7&scoped=true&lang=css"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465e82f7"]])

export default __exports__